// Importar os ícones que você quer usar
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSpinner,
  faBuilding,
  faTachometerAlt,
  faUsers,
  faUsersCog,
  faDownload,
  faSearch,
  faEdit,
  faTrash,
  faPlus,
  faEye,
  faEyeSlash,
  faSignOutAlt,
  faUser,
  faLock,
  faLockOpen,
  faEnvelope,
  faCheck,
  faCheckCircle,
  faTimes,
  faExclamationTriangle,
  faInfoCircle,
  faCalendar,
  faFileAlt,
  faCog,
  faHome,
  faBars,
  faTimes as faTimesCircle,
  faLink,
  faSave,
  faBell,
  faPause,
  faPlay,
  faFileInvoice,
  faFileInvoiceDollar,
  faUserCog,
  faQuestionCircle,
  // Ícones para FileManager
  faFolder,
  faFolderOpen,
  faUpload,
  faTh,
  faList,
  faSitemap,
  faChevronRight,
  faFilePdf,
  faCloudUploadAlt,
  faShare,
  faArrowRight,
  faExternalLinkAlt,
  // Ícones para ordenação
  faSort,
  faSortUp,
  faSortDown,
  faChartBar,
  faCertificate,
  faFileDownload,
  faSync,
  faMinus,
  faKey,
  faFileExcel,
  faExclamationCircle,
  faMousePointer,
  faPaperPlane,
  faChartPie,
  faCalendarAlt,
  faCalendarTimes,
  faChevronLeft,
  faSatelliteDish,
  faClipboardCheck,
} from "@fortawesome/free-solid-svg-icons";

// Adicionar os ícones à biblioteca
library.add(
  faSpinner,
  faBuilding,
  faTachometerAlt,
  faUsers,
  faUsersCog,
  faDownload,
  faSearch,
  faEdit,
  faTrash,
  faPlus,
  faEye,
  faEyeSlash,
  faSignOutAlt,
  faUser,
  faLock,
  faLockOpen,
  faEnvelope,
  faCheck,
  faCheckCircle,
  faTimes,
  faExclamationTriangle,
  faInfoCircle,
  faCalendar,
  faFileAlt,
  faCog,
  faHome,
  faBars,
  faTimesCircle,
  faLink,
  faSave,
  faBell,
  faPause,
  faPlay,
  faFileInvoice,
  faFileInvoiceDollar,
  faUserCog,
  faQuestionCircle,
  // Ícones para FileManager
  faFolder,
  faFolderOpen,
  faUpload,
  faTh,
  faList,
  faSitemap,
  faChevronRight,
  faFilePdf,
  faCloudUploadAlt,
  faShare,
  faArrowRight,
  faExternalLinkAlt,
  // Ícones para ordenação
  faSort,
  faSortUp,
  faSortDown,
  faChartBar,
  faCertificate,
  faFileDownload,
  faSync,
  faMinus,
  faKey,
  faFileExcel,
  faExclamationCircle,
  faMousePointer,
  faPaperPlane,
  faChartPie,
  faCalendarAlt,
  faCalendarTimes,
  faChevronLeft,
  faSatelliteDish,
  faClipboardCheck
);
